import { useCurrentAccount } from '@alliance-disposal/client';
import type { FeatureFlag } from '@alliance-disposal/client';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { RouterOutletContext } from '../router';

interface FeatureFlagWrapperProps {
    requiredFeatureFlag: FeatureFlag;
}

const FeatureFlagWrapper = ({ requiredFeatureFlag }: FeatureFlagWrapperProps) => {
    const context = useOutletContext<RouterOutletContext>();
    const { featureFlags } = useCurrentAccount();

    if (!featureFlags.includes(requiredFeatureFlag)) {
        return <Navigate to="/404" replace />;
    }

    return <Outlet context={context} />;
};

export default FeatureFlagWrapper;
